// extracted by mini-css-extract-plugin
export default {"switchAnswer":"styles_switchAnswer__XqNud","switchBadge":"styles_switchBadge__AOq36","active":"styles_active__oxOQV"};